import React from 'react';
import '../../App.css';
import './News.css';
import Footer from '../Footer';
import { useTranslation } from "react-i18next";
import { GooglePlayButton } from "../GooglePlayButton";
import { AppStoreButton } from '../AppStoreButton';

export default function About() {

  const { t } = useTranslation();

  return <div className="news-container">
    <div className="about-form">

      <h2>{t('text.news1')}</h2>
      <br></br>
      <p>{t('text.news2')}</p>
      <p><strong>{t('text.news3')}</strong></p>
      <br></br>
      <h3>{t('text.news4')}</h3>
      <ul>
        <li><strong>{t('text.news5')}</strong></li>
        <li><strong>{t('text.news6')}</strong></li>
        <li><strong>{t('text.news7')}</strong></li>
        <li><strong>{t('text.news8')}</strong></li>
      </ul>
      <p>{t('text.news9')}</p>
      <br></br>
      <h3>{t('text.news10')}</h3>
      <p>{t('text.news11')}</p>
      <br></br>
      <h3>{t('text.news12')}</h3>
      <ul>
        <li>{t('text.news13')}</li>
        <li>{t('text.news14')}</li>
        <li>{t('text.news15')}</li>
      </ul>
      <p>{t('text.news16')}</p>
      <p>{t('text.news17')}</p>
      <br></br>
      <div class="button-container-news">
        <GooglePlayButton url="https://play.google.com/store/apps/details?id=cz.midnighttree.questown"></GooglePlayButton>
        <AppStoreButton url="https://apps.apple.com/cz/app/questown/id6742157352"></AppStoreButton>
      </div>
    </div>
    <Footer />
  </div>
}
